import Vue from 'vue'
import { sortSlideOptionsInPlace } from '@/utils/slide-options-sort'

const setSlideActive = (state, payload) => {
  if (payload.type === 'multipleChoice') {
    payload.typeChart = payload.typeChart || 'barChart'
  }
  // Normalise option order: the active slide can arrive from a server detail fetch
  // whose SlideOptions are unsorted (e.g. setPresentFromBeginningAction). See
  // utils/slide-options-sort.js.
  sortSlideOptionsInPlace(payload)
  state.slideActive = {
    ...payload,
  }

  // fixing techdebt in progress
  // create another state called activeSlideId
  // hopefully someday can delete staet.slideActive
  // issue: https://ahaslides.atlassian.net/browse/AHA-5613
  // ask Loi Hoang, Huong Nguyen or Linh Vu if you dont understand
  state.activeSlideId = state.slideActive && state.slideActive.id
  state.presentation.slides = state.presentation.slides.map((item) => {
    if (!item.id || item.id !== state.slideActive.id) return item
    return state.slideActive
  })
  if (state.slideActive && state.slideActive.id) {
    state.lastSlideActiveId = state.slideActive.id
  }
}

const setSlideEnterFadePhase = (state, phase) => {
  state.slideEnterFadePhase = phase
}

const checkSlideMovingDirection = (state, currentSlideId) => {
  const previousIndex = state.previousSlideIndex !== null && state.previousSlideIndex !== undefined
    ? state.previousSlideIndex
    : -1
  const currentIndex = state.presentation.slides.findIndex((item) => currentSlideId === item.id)
  // The transient { id: null } clear-canvas frame a forward Next emits (and any id
  // not in the deck) resolves to -1 here, producing a bogus backward move that
  // wrongly clears continueQuiz. A full-quiz plugin re-mounts QuizSlideContent on
  // every slide entry (keyed), so its mounted() then reads continueQuiz=false and
  // falls back to the lobby instead of auto-starting the game like a native quiz.
  // Only compute the direction for a slide that is actually in the deck.
  if (currentIndex === -1) return
  state.slideMovingDirection = currentIndex - previousIndex
  state.previousSlideIndex = currentIndex

  if (state.slideMovingDirection < 0 && state.continueQuiz) {
    state.continueQuiz = false
  }
}

export const updateSlideActive = (state, payload) => {
  // some responses from old active slide are comming back when
  // active slide is already changed
  if (payload.slideId && state.slideActive.id !== payload.slideId) return

  state.slideActive = { ...state.slideActive, ...payload }

  // fixing techdebt in progress
  // create another state called activeSlideId
  // hopefully someday can delete staet.slideActive
  // issue: https://ahaslides.atlassian.net/browse/AHA-5613
  // ask Loi Hoang, Huong Nguyen or Linh Vu if you dont understand
  state.activeSlideId = state.slideActive && state.slideActive.id
  state.presentation.slides = state.presentation.slides.map((item) => {
    if (!item.id || item.id !== state.slideActive.id) return item
    return state.slideActive
  })
  if (state.slideActive && state.slideActive.id) {
    state.lastSlideActiveId = state.slideActive.id
  }
}

const updateSlideById = (state, payload) => {
  if (payload.id === state.slideActive.id) {
    state.slideActive = {
      ...state.slideActive,
      ...payload,
    }
  }
  state.presentation.slides = state.presentation.slides.map((item) => {
    if (!item.id || item.id !== payload.id) return item
    return {
      ...item,
      ...payload,
    }
  })
}

// Sets notes in place instead of replacing the slide object like updateSlideById: a new
// slideActive object re-renders every panel bound to it, which drops their unsaved local
// state (e.g. a placeholder option's open crop dialog, whose v-for key changes on re-render).
const setSlideNotes = (state, { slideId, notes }) => {
  if (state.slideActive?.id === slideId) Vue.set(state.slideActive, 'notes', notes)
  const slide = state.presentation?.slides?.find((item) => item.id === slideId)
  if (slide) Vue.set(slide, 'notes', notes)
}

const setStartPresentingFromSlideId = (state, payload) => {
  state.startPresentingFromSlideId = payload
}

const setPendingCanvasBlockPayload = (state, payload) => {
  state.pendingCanvasBlockPayload = payload
}

const setOriginScreen = (state, payload) => {
  state.originScreen = payload
}

export default {
  updateSlideActive,
  updateSlideById,
  setSlideNotes,
  setSlideActive,
  setSlideEnterFadePhase,
  checkSlideMovingDirection,
  setStartPresentingFromSlideId,
  setPendingCanvasBlockPayload,
  setOriginScreen,
}
